<div class="">
  <app-order-filter (filterUpdate)="onFilterUpdate($event)" (onDownload)="onDownload($event)"
    [filter]="filter$ | async"></app-order-filter>
  <div class=''>
    <div class="overlay-container">
      <span *ngIf="limit$|async as limit">
        <p-table #serviceOrders [value]="orders$|async"  (onLazyLoad)="getData($event)" styleClass="table table-primary"
          [paginator]="true" [rows]="limit" [totalRecords]="(total$|async)" [lazy]="true"
          [loading]="(serviceOrderState$|async).isLoading">
          <ng-template pTemplate="header">
            <tr>
              <th>#</th>
              <th>Customer</th>
              <th span="2">Service</th>
              <th>Quantity</th>
              <th>Amount</th>
              <th>Payment</th>
              <th>District</th>
              <th>Order Date</th>
              <th>Status</th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-order let-rowIndex="rowIndex">
            <tr>
              <td>{{((page$|async)*limit+rowIndex+1)-(limit$|async)}}</td>
              <td>
                <div class="font-weight-bold">{{order.farmer_name||'NA'}}</div>
                <div>{{order.farmer_contact||'NA'}}</div>
              </td>
              <td>
                <div class="font-weight-bold">{{order.service_name||'NA'}}</div>
                <div *ngIf="order.type!=='farm_plan_order'">{{order.service_provider||'NA'}}</div>
                <ng-container *ngIf="order.type==='farm_plan_order' && order.farm_plan_name as farm_plan_name">
                  <div class="font-weight-normal">
                    {{ farm_plan_name }}
                  </div>
                </ng-container>
              </td>
              <td>
                {{order|formatQty}}{{' '}}<span>{{order|formatQty:'unit'}}</span>
                <div *ngIf='order.type==="map_cordinates"'>
                  <div class="font-weight-bold" *ngIf="order.deviceModel != undefined">
                    Device Model: <span class="font-weight-normal">{{ order.deviceModel}} </span>
                  </div>
                  <div class="font-weight-bold" *ngIf="order.averageAccuracy != undefined">
                    Average Accuracy: <span class="font-weight-normal">{{ order.averageAccuracy }}</span>
                  </div>
                </div>
                <div *ngIf='order.type==="farm_plan_order"'>
                  <div class="font-weight-bold">
                    Crop: <span class="font-weight-normal">{{ order.crop}} </span>
                  </div>
                </div>
              </td>
              <td>{{order.total_cost}}</td>
              <td>{{order.payment|uppercase}}</td>
              <td>{{order.farmer_district}}</td>
              <td>{{order.date|dateFormatPipe}}</td>
              <td>{{order.status|uppercase}}</td>
              <td>
                <div class="dropdown">
                  <button type="button" class="btn btn-outline-secondary dropdown-toggle" id='{{order.id}}'
                    data-toggle="modal" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                    [disabled]='order.isLoading' (click)="selectOrder(order)">
                    <span *ngIf="order.isLoading" class="spinner-border spinner-border-sm" role="status"
                      aria-hidden="true"></span>
                    Action</button>
                  <div class="dropdown-menu" aria-labelledby="actionMenu">
                    <a class="dropdown-item" data-target="#serviceOrderDetailsModal" data-backdrop='static'
                      data-toggle="modal" (click)="selectOrder(order)">View
                      Details</a>
                    <a class="dropdown-item text-danger" *ngIf="order.status.toLowerCase()==='new'"
                      (click)='deleteOrder(order)' [class.disabled]="!order.id">Delete
                    </a>
                  </div>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="summary">
            <div class="row justify-content-md-center">
              <div class="col">
                Total: {{(ordersAmountTotal$|async|currency:'UGX')}}
              </div>
              <div class="col">
                Unique Farmers: {{(uniqueFarmers$|async)}}
              </div>
            </div>
          </ng-template>
        </p-table>
      </span>
    </div>
    <app-service-order-details-modal *ngIf="selectedOrder$ | async as selectedOrder" [order]="selectedOrder">
    </app-service-order-details-modal>
  </div>
</div>
<span (click)="handleRefreshTable()" class="data-indicator">
  <i class="fa fa-refresh" [class.live]='(serviceOrderState$|async).isLoading' aria-hidden="true"></i>
</span>
